document.addEventListener('DOMContentLoaded', function () {
    // Get all component tab containers
    const tabContainers = document.querySelectorAll('.component-tabs');

    // If no tabContainers are found, terminate early
    if (tabContainers.length === 0) return;

    // Function to reset the tab state (color and active classes)
    const resetTabState = (tab) => {
        const svgIcon = tab.querySelector('svg');
        const circle = svgIcon?.querySelector('circle');
        const path = svgIcon?.querySelector('path');
        
        tab.classList.remove('active');
        circle?.classList.remove('fill-[#00134E]');
        path?.classList.remove('fill-[#FFFFFF]');
        
        const content = tab.querySelector('.component-tabs__tab__content');
        content?.classList.add('hidden');
    };

    // Function to set the tab as active
    const setActiveTab = (tab, contentArea) => {
        const svgIcon = tab.querySelector('svg');
        const circle = svgIcon?.querySelector('circle');
        const path = svgIcon?.querySelector('path');
        
        tab.classList.add('active');
        circle?.classList.add('fill-[#00134E]');
        path?.classList.add('fill-[#FFFFFF]');
        
        const content = tab.querySelector('.component-tabs__tab__content');
        content?.classList.remove('hidden');
        contentArea.innerHTML = content?.innerHTML || '';  // Update content area for desktop
    };

    // Function to initialize tabs for each tab container
    const initializeTabs = (tabContainer) => {
        const tabs = tabContainer.querySelectorAll('.component-tabs__tab');
        const contentArea = tabContainer.querySelector('.component-tabs__content-area');
        const isDesktop = window.innerWidth >= 1024;

        // Initialize first tab as active (both for mobile and desktop)
        tabs.forEach((tab, index) => {
            const content = tab.querySelector('.component-tabs__tab__content');
            if (!content) return;  // Skip tabs without content

            // Default content display for the first tab (for mobile and desktop)
            if (index === 0) {
                if (isDesktop) {
                    content.classList.add('hidden');
                    contentArea.innerHTML = content.innerHTML;
                } else {
                    content.classList.remove('hidden');
                }
                setActiveTab(tab, contentArea);
            } else {
                content.classList.add('hidden');
            }
        });

        // Attach event listeners for tab clicks
        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                tabs.forEach(resetTabState);  // Reset all tabs
                setActiveTab(tab, contentArea);  // Set clicked tab as active
            });
        });
    };

    // Iterate through all component tab containers on the page
    tabContainers.forEach(tabContainer => {
        initializeTabs(tabContainer);  // Initialize tabs for each container
    });

    // Reinitialize the tabs on window resize
    window.addEventListener('resize', () => {
        tabContainers.forEach(tabContainer => {
            initializeTabs(tabContainer);
        });
    });
});
